<template>
  <div>
    <ssg-messagebox
      titles="新建关联企业项目"
      v-if="maskshow"
      @sub="addJobNumberRule"
      width="500px"
      height="auto"
    >
      <div class="form">
        <el-form
          :model="addForm"
          :rules="rules"
          ref="addForm"
          label-width="100px"
          label-position="right"
        >
          
          <el-form-item
            label="用工平台账号"
            prop="isMust"
            haveto="true"
            style="margin-bottom: 20px"
          >
            <el-input
              v-model="addForm.isMust"
              placeholder="请输入用工平台账号"
              :maxlength="11"
              style="width: 268px"
            ></el-input>
            <button
              class="btn subbtn"
              style="margin-left: 16px"
              @click="detect"
              type="button"
            >
              检测
            </button>
          </el-form-item>
          <el-form-item
            label="关联企业"
            prop="company"
            style="margin-bottom: 20px"
          >
            <el-select
              style="width: 346px"
              v-model="addForm.company"
              placeholder="请选择"
              :disabled="disabled"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="
                  item.name +
                  (item.is_relation == true ? ' (已关联)' : '')
                "
                :disabled="item.is_relation"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </ssg-messagebox>
    <div class="box">
      <p class="return" @click="$router.go(-1)">返回</p>
      <span class="line">|</span>
      <p class="contract back" @click="backTo">项目列表</p>
      <span class="lines">></span>
      <p class="contract">关联设置</p>
    </div>
    <div class="sign adaptation" style="padding: 0">
      <div class="tab_nav">
        <div class="tab_search">
          <div>
            <span class="checkedss"> 嗖嗖用工关联企业 </span>
          </div>
        </div>
        <div class="bbt" v-if="list.length !== 0">
          <button class="btn subbtn" @click="add(true)">新建关联企业项目</button>
        </div>
      </div>

      <div class="table">
        <!-- <page
          v-show="list.length > 0"
          :page="pageNo"
          :pagesize.sync="pageSize"
          :total="total"
          ref="page"
          @currentChange="cur"
          @enter="cur"
        ></page> -->
        <div class="tab" v-for="(v, k) in list" :key="k">
          <div class="ynum line company_name">
            <p>
              <span class="titles">
                {{ v.company_name }}
              </span>
            </p>
          </div>

          <div class="ynum three">
            <p>管理员</p>
            <p style="margin-top: 10px;">{{ v.user_name }}</p>
          </div>

          <div class="ynum three">
            <p>申请时间</p>
            <p style="margin-top: 10px">{{ v.create_date }}</p>
          </div>
          <div class="name">
            <p style="font-size: 12px; color: #9393a2; text-align: center">
              操作
            </p>
            <div style="margin-top: 10px" class="opera">
              <div>
                <span @click="edit(v.project_id,v.company_id)">编辑</span>
              </div>
              <div>
                <span
                  v-if="v.applyRelationState == 1 || v.applyRelationState !== 3"
                  @click="agree(v.project_id, v.company_name, v.company_id)"
                  >取消关联</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="bgnull" v-if="list.length == 0">
          <div class="bg"></div>
          <div class="nobg">您还没有关联项目</div>
          <div class="span">请点击下方按钮进行关联</div>
          <div class="bbt">
            <button class="btn subbtn" @click="add(true)">新建关联企业项目</button>
          </div>
        </div>
        <!-- <page
          v-show="list.length > 0"
          :page="pageNo"
          :pagesize.sync="pageSize"
          :total="total"
          ref="page"
          @currentChange="cur"
          @enter="cur"
        ></page> -->
      </div>
    </div>
  </div>
</template>
<script>
import treeToArray from "../../common/TreeTable/eval";
export default {
  created() {
    this.totals = this.$route.params.totals;
    this.noconnect = this.$route.params.noconnect;
    this.yesORno = this.$route.params.yesORno;
    this.loadData();
    this.getBatchTaskExecuteInfo();
    this.$once("hook:beforeDestroy", () => {
      clearTimeout(this.timeout);
    });
  },
  mounted() {
    this.btnPermissionsStr = sessionStorage.getItem("btnPermissions");

    // this.$nextTick(() => {
    //   if (this.yesORno) {
    //     (this.maskshow = true),
    //       (this.masktype = "pushFile"),
    //       (this.totals = this.$route.params.totals),
    //       (this.noconnect = this.$route.params.noconnect);
    //   }
    // });
  },
  data() {
    let validatePass2 = (rule, value, callback) => {
      if (this.erromess) {
        callback(new Error("未检测到该企业账号"));
      } else {
        callback();
      }
    };
    return {
      erromess: "",
      rules: {
        name: [
          {
            required: true,
            message: "请选择关联平台",
            trigger: "change",
          },
        ],
        isMust: [
          {
            required: true,
            message: "请输入用工平台账号",
            trigger: "blur",
          },
          {
            validator: function (rule, value, callback) {
              if (/^1[3456789]\d{9}$/.test(value) == false) {
                callback(new Error("手机号格式错误"));
             
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          {
            validator: validatePass2,
          },
        ],
        company: [
          {
            required: true,
            message: "请选择关联企业",
            trigger: "change",
          },
        ],
      },
      btnPermissionsStr: {},
      yesORno: false,
      list: [],
      maskshow: false,
      pageNo: 1,
      pageSize: 10,
      id: "",
      // total: 0,
      companyList: [],
      disabled: true,
      addForm: {
        name: "1",
        isMust: "",
        company: "",
      },
    };
  },
  watch: {
    // pageNo: function (val, oldVal) {
    //   this.$refs.page.page = val;
    // },
  },
  created() {
    this.loadData();
    // this.yesORno = this.$route.params.yesORno;
  },
  methods: {
    changeResult(isTrue) {
     
      this.addForm.name = isTrue;
    },
    //检测
    detect() {
      this.erromess = ""; 
      this.$refs.addForm.validateField("isMust", (message) => {     
       
        if (!message) {
          this.$axios
            .get(
              "/eem/relevance/checkCompany?projectId=" +
                this.$route.query.id +
                "&mobile=" +
                this.addForm.isMust
            )
            .then((res) => {
              this.companyList = [];
              if (res.data.status == 1) {
                this.companyList = res.data.data;
                if (this.companyList) {
                  this.disabled = false;
                }
              } else {
                // this.addForm.company = "";  
                this.companyList = [];
             
                this.disabled = true;
                this.erromess = res.data.message;
                this.$refs.addForm.validateField("isMust");

              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
    edit(id, companyId,name) {
      this.$router.push({
        path: "/ssgNewAttend/relateSet/attendPower",
        query: {
          projectId: id,
          companyId: companyId,
        },
      });
    },
    add(mess) {
      this.addForm = {};
      this.addForm.name  = '1'
      this.companyList = [];
      this.maskshow = mess;
      this.disabled = true;
    },
    addJobNumberRule() {
      this.$refs.addForm.validate((status) => {
        if (status == true) {
          const params =
            "projectId=" +
            this.$route.query.id +
            "&companyId=" +
            this.addForm.company;
          return this.$axios
            .post("/eem/relevance/insert", params)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.maskshow = false;
                this.loadData();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch((err) => {
              //处理错误
              console.error(err);
            });
        }
      });
    },

    back() {
      this.$router.push({ path: "/main" });
    },
    backTo() {
      this.$router.push({
        path: "/ssgNewAttend",
      });
    },

    loadData() {
      const params = {
        projectId: this.$route.query.id,
      };
      return this.$axios
        .get("/eem/relevance/list", {
          params,
        })
        .then((res) => {
        
          this.list = res.data.data;
          // this.total = res.data.data.total;

          //   if( this.pageNo!==1 && this.list.length==0){
          //     this.pageNo = this.pageNo-1
          //     this.loadData()
          //   }
          // this.noticeStatus = res.data.data.noticeStatus -1;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    agree(id, name, companyId) {
      this.$confirm(
        `<p style="margin-bottom:10px;font-size: 16px;font-weight: bold;color: #303140;margin-top: 10px;">您确定<span  style="color:#FF6752;font-weight: bold">取消关联</span>【${name}】项目吗？</p>`,
        "取消关联",
        {
          confirmButtonText: "确定取消",
          cancelButtonText: "我再想想",
          dangerouslyUseHTMLString: true,
          iconClass: "el-icon-caveat",
        }
      )
        .then(() => {
          this.$axios
            .delete("/eem/relevance/delete?projectId=" + id + '&companyId=' + companyId)
            .then((res) => {
              if (res.data.status == 1) {
                this.$message.success(res.data.message);
                this.loadData();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {});
    },

    cur(val) {
      this.pageNo = val;
      this.loadData();
    },
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">
.box {
  display: flex;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}

.sign {
  width: 100%;
  height: 100%;
  padding: 0 50px;
  box-sizing: border-box;

  /*background-color: #fff;
          border: 1px solid #d9dbe2;
          border-radius: 6px 6px 0 0;*/
  .operating {
    width: 100%;
    min-height: 62px;
    line-height: 62px;
    box-sizing: border-box;

    .search {
      margin-right: 14px;
    }
  }

  .table {
    width: 100%;

    .tab {
      width: 100%;
      height: 98px;
      display: flex;
      align-items: center;
      border: 1px solid #d9dbe2;
      border-radius: 12px;
      margin-bottom: 15px;
      padding: 14px 0;
      box-sizing: border-box;
      position: relative;

      .name {
        width: 139px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 16px;
        color: #6669e3;
        border-left: 1px solid #f2f5f8;
      }
      .status {
        width: 20%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: inherit;
        font-size: 12px;
        color: #9393a2;
      }
      .company_name {
        width: 30%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 25px;
        font-size: 16px;
          p:first-child {
          color: #9393a2;
        }

        p:last-child {
          color: #545566;
        }

      }

      .three {
        width: 30%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        font-size: 12px;

        p:first-child {
          color: #9393a2;
        }

        p:last-child {
          color: #545566;
        }
      }

      .axis {
        width: 40%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .bgnull {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .bg {
        width: 262px;
        height: 143px;
        background-image: url(../../../assets/img/noplat.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 262px 143px;
        margin-top: 146px;
      }
      .nobg {
        font-size: 16px;
        font-weight: bold;
        color: #545566;
        margin-top: -35px;
      }
      .span {
        font-size: 14px;
        color: #545566;
      }
      .bbt {
        margin-top: 30px;
      }
    }
  }
}

.opera {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #6669e3;
  span {
    margin: 0 5px;
    color: #6669e3;

    cursor: pointer;
  }
}

.checkedss {
  width: 192px;
  height: 37px;
  font-size: 24px;
  font-weight: bold;
  color: #303140;
  line-height: 36px;
}

.el-icon-question:before {
  content: "\e7a4";
  position: absolute;
  padding-left: 10px;
  margin: -10px auto;
}

.title {
  font-size: 6px;
  font-weight: 400;
  color: #545566;
}
.line {
  border-right: 1px solid #f2f5f8;
  .titles {
    font-size: 14px;
    font-weight: bold;
    color: #303140;
  }
}
.el-message-box__input /deep/ .el-input {
  width: 0;
}
</style>
